import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import store from './store/index'
import { version } from '../package.json'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/marketplace/Index'),
      children: [
        {
          name: 'shop',
          path: 'shop/:name',
          component: () => import('@/views/marketplace/Store'),
        },
        {
          name: 'video',
          path: 'videochat',
          component: () => import('@/views/marketplace/components/core/VideoChat'),
        },
        {
          name: 'storefront',
          path: 'store',
          component: () => import('@/views/marketplace/StoreFront'),
          children: [
            {
              path: ':id',
              components: {
                default: import('@/views/marketplace/StoreFront'),
                categoryViews: () => import('@/views/marketplace/StoreList'),
              },
            },
          ],
        },
        {
          name: 'home',
          path: '',
          component: () => import('@/views/landing/Home'),
        },
        {
          name: 'videochat',
          path: 'videochat',
          component: () => import('@/views/marketplace/components/core/VideoChat'),
        },
        {
          name: 'search',
          path: 'search',
          props: true,
          component: () => import('@/views/marketplace/MarketPlace'),
        },
        {
          name: 'my-requests',
          path: 'my-requests',
          component: () => import('@/views/marketplace/component/profile/MyRequest'),
        },
        {
          name: 'cart',
          path: 'cart',
          component: () => import('@/views/marketplace/components/BasketModal'),

        },
        {
          name: 'notifications',
          path: 'notifications',
          props: true,
          component: () => import('@/views/custom/Notifications'),
        },
        {
          name: 'Perfil',
          path: 'profile/:favorites?',
          props: true,
          component: () => import('@/views/marketplace/component/UserProfile'),
        },
        // CMS
        {
          name: 'Blog',
          path: 'blog',
          component: () => import('@/views/custom/CMS/Blogs'),
        },
        {
          name: 'Post',
          path: 'post/:id',
          component: () => import('@/views/custom/CMS/Post'),
        },
        {
          name: 'Statics',
          path: 'tender/:title',
          component: () => import('@/views/custom/CMS/Statics'),
        },
      ],
    },
    // {
    //   path: '/market',
    //   component: () => import('@/views/marketplace/Index'),
    //   children: [
    //     {
    //       name: 'shop',
    //       path: 'shop/:id',
    //       component: () => import('@/views/marketplace/Store'),
    //     },
    //     {
    //       name: 'video',
    //       path: 'videochat',
    //       component: () => import('@/views/marketplace/components/core/VideoChat'),
    //     },
    //     {
    //       name: 'storefront',
    //       path: 'store',
    //       component: () => import('@/views/marketplace/StoreFront'),
    //       children: [
    //         {
    //           path: ':id',
    //           components: {
    //             default: import('@/views/marketplace/StoreFront'),
    //             categoryViews: () => import('@/views/marketplace/StoreList'),
    //           },
    //         },
    //       ],
    //     },
    //     {
    //       name: 'home',
    //       path: '',
    //       component: () => import('@/views/marketplace/Home'),
    //     },
    //     {
    //       name: 'videochat',
    //       path: 'videochat',
    //       component: () => import('@/views/marketplace/components/core/VideoChat'),
    //     },
    //     {
    //       name: 'search',
    //       path: 'search',
    //       props: true,
    //       component: () => import('@/views/marketplace/MarketPlace'),
    //     },
    //     {
    //       name: 'my-requests',
    //       path: 'my-requests/:type?',
    //       component: () => import('@/views/custom/transactions/Requests'),
    //     },
    //     {
    //       name: 'cart',
    //       path: 'cart',
    //       component: () => import('@/views/marketplace/components/BasketModal'),
    //
    //     },
    //     {
    //       name: 'notifications',
    //       path: 'notifications',
    //       props: true,
    //       component: () => import('@/views/custom/Notifications'),
    //     },
    //     {
    //       name: 'Profile',
    //       path: 'profile',
    //       component: () => import('@/views/marketplace/component/UserProfile'),
    //     },
    //
    //   ],
    // },
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Lock',
          path: 'lock',
          component: () => import('@/views/pages/Lock'),
        },
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login'),
        },
        {
          name: 'Pricing',
          path: 'pricing',
          component: () => import('@/views/custom/pricing/Pricing'),
        },
        {
          name: 'Register',
          path: 'register/:referralCode?',
          props: true,
          component: () => import('@/views/pages/Register'),
        },
        {
          name: 'Terms',
          path: 'terms',
          component: () => import('@/views/pages/Terms'),
        },
      ],
    },
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'Detalles',
          path: 'userDetails/:type?',
          props: true,
          component: () => import('@/components/custom/userDetails'),
        },
        {
          name: 'Tutoriales',
          path: 'tutorials',
          component: () => import('@/components/custom/tutorials/videosHowToUse'),
        },
        // transactions
        {
          name: 'Transactions',
          path: 'transactions',
          component: () => import('@/views/custom/Transactions'),
          children: [
            {
              name: 'Transacciones',
              path: ':type',
              component: () => import('@/views/custom/Transactions'),
            },
          ],
        },
        {
          name: 'Transactions',
          path: 'transactions-list',
          component: () => import('@/views/dashboard/pages/Lists/TransactionsLists'),
        },
        // marketplace
        {
          name: 'market-place',
          path: 'marketplace',
          component: () => import('@/views/custom/marketplace/MarketPlace'),
        },
        // Home
        {
          name: 'Home',
          path: 'Home',
          component: () => import('@/views/dashboard/Home'),
        },
        // shops
        {
          name: 'Crear Tienda',
          path: 'create-shop',
          component: () => import('@/views/custom/CreateShop'),
        },
        {
          name: 'Mis Tiendas',
          path: 'shops-list',
          component: () => import('@/views/dashboard/pages/Lists/ShopsLists'),
        },
        {
          name: 'Tiendas',
          path: 'shops',
          component: () => import('@/views/custom/Shops'),
          children: [
            {
              name: 'shops',
              path: ':id/:metrics?',
              component: () => import('@/views/custom/Shops'),
            },
          ],
        },
        // Products List
        {
          name: 'Productos',
          path: 'products',
          component: () => import('@/views/custom/Products'),

        },
         // Providers List
        {
          name: 'Proveedores',
          path: 'providers',
          component: () => import('@/views/custom/Providers'),
        },
        // Inventory List
        {
          name: 'Inventory',
          path: 'products/inventory',
          component: () => import('@/views/custom/Inventory'),
        },
        // Collaborators
        {
          name: 'Colaboradores',
          path: 'collaborators',
          component: () => import('@/views/custom/Users'),
        },
        // Profile
        {
          name: 'Perfil',
          path: 'profile',
          component: () => import('@/views/custom/UserProfile'),
        },
        // Clients
        {
          name: 'Clients',
          path: 'clients',
          component: () => import('@/views/custom/Clients'),
        },
        // Dashboard
        {
          name: 'Home',
          path: '',
          component: () => import('@/views/dashboard/Home'),
        },
        {
          name: 'Metricas generales',
          path: 'metrics',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Notificaciones',
          path: 'notifications',
          component: () => import('@/views/custom/Notifications'),
        },
        // Mp
        {
          name: 'Codigo mercadopago',
          path: 'mercadopago/:code',
          component: () => import('@/views/custom/MP/GetCode'),
        },
        // Pages
        {
          name: 'RTL',
          path: 'pages/rtl',
          component: () => import('@/views/dashboard/pages/Rtl'),
        },
        {
          name: 'Perfil de usuario',
          path: 'pages/user',
          component: () => import('@/views/dashboard/pages/UserProfile'),
        },
        {
          name: 'Timeline',
          path: 'pages/timeline',
          component: () => import('@/views/dashboard/pages/Timeline'),
        },
        // Components
        {
          name: 'Buttons',
          path: 'components/buttons',
          component: () => import('@/views/dashboard/component/Buttons'),
        },
        {
          name: 'Grid System',
          path: 'components/grid-system',
          component: () => import('@/views/dashboard/component/Grid'),
        },
        {
          name: 'Tabs',
          path: 'components/tabs',
          component: () => import('@/views/dashboard/component/Tabs'),
        },
        {
          name: 'Notifications',
          path: 'components/notifications',
          component: () => import('@/views/dashboard/component/Notifications'),
        },
        {
          name: 'Icons',
          path: 'components/icons',
          component: () => import('@/views/dashboard/component/Icons'),
        },
        {
          name: 'Typography',
          path: 'components/typography',
          component: () => import('@/views/dashboard/component/Typography'),
        },
        // Forms
        {
          name: 'Regular Forms',
          path: 'forms/regular',
          component: () => import('@/views/dashboard/forms/RegularForms'),
        },
        {
          name: 'Extended Forms',
          path: 'forms/extended',
          component: () => import('@/views/dashboard/forms/ExtendedForms'),
        },
        {
          name: 'Validation Forms',
          path: 'forms/validation',
          component: () => import('@/views/dashboard/forms/ValidationForms'),
        },
        {
          name: 'Wizard',
          path: 'forms/wizard',
          component: () => import('@/views/dashboard/forms/Wizard'),
        },
        // Tables
        {
          name: 'Regular Tables',
          path: 'tables/regular-tables',
          component: () => import('@/views/dashboard/tables/RegularTables'),
        },
        {
          name: 'Extended Tables',
          path: 'tables/extended-tables',
          component: () => import('@/views/dashboard/tables/ExtendedTables'),
        },
        {
          name: 'Data Tabels',
          path: 'tables/data-tables',
          component: () => import('@/views/dashboard/tables/DataTables'),
        },
        // Maps
        {
          name: 'Google Maps',
          path: 'maps/google-maps',
          component: () => import('@/views/dashboard/maps/GoogleMaps'),
        },
        {
          name: 'Full Screen Map',
          path: 'maps/full-screen-map',
          component: () => import('@/views/dashboard/maps/FullScreenMap'),
        },
        // Root level
        {
          name: 'Widgets',
          path: 'widgets',
          component: () => import('@/views/dashboard/Widgets'),
        },
        {
          name: 'Charts',
          path: 'charts',
          component: () => import('@/views/dashboard/Charts'),
        },
        {
          name: 'Calendar',
          path: 'calendar',
          component: () => import('@/views/dashboard/Calendar'),
        },
        {
          name: 'Planes',
          path: 'plans',
          component: () => import('@/views/custom/plans/Plans'),
        },
        {
          name: 'NewCard',
          path: 'newcard',
          component: () => import('@/views/custom/plans/NewCard'),
        },
        {
          name: 'Manejador de planes',
          path: 'planner',
          props: true,
          component: () => import('@/views/custom/plans/Planner'),
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/admin',
      name: 'Admin',
      component: () => import('@/views/admin/Index'),
      children: [
        // Mantenedor de Usuarios
        {
          name: 'Mantenedor de Usuarios',
          path: '',
          component: () => import('@/views/admin/pages/UserMaintainer'),
        },
        {
          name: 'Lista de Usuarios',
          path: 'users-list',
          component: () => import('@/views/admin/pages/UserMetrics'),
        },
        // informacion de retiros
        {
          name: 'Informacion de retiros',
          path: 'withdraw',
          component: () => import('@/views/admin/pages/Withdraw'),
        },
        // informacion de retiros
        {
          name: 'Informacion de retiros por cliente',
          path: 'withdraw-by-client',
          component: () => import('@/views/admin/pages/WithdrawByClient'),
        },
        // todos los clientes que tienen al menos 1 referido
        {
          name: 'Lista de clientes con referidos ',
          path: 'clients-with-referrals',
          component: () => import('@/views/admin/pages/ClientsWithReferrals'),
        },
        // habilitar/deshabilitar clientes
        {
          name: 'Habilitar/Deshabilitar clientes ',
          path: 'enab-disb-clients',
          component: () => import('@/views/admin/pages/EnabDisbClients'),
        },
        // Mantenedor de Planes
        {
          name: 'Mantenedor de Planes',
          path: 'plansMaintainer',
          component: () => import('@/views/admin/pages/PlansMaintainer'),
        },
        // Mantenedor de Paginas
        {
          name: 'Mantenedor de páginas',
          path: 'page-maintainer',
          component: () => import('@/views/admin/pages/CMS/Index'),
        },
        {
          name: 'Cargar botsol csv',
          path: 'upload-botsol-csv',
          component: () => import('@/views/admin/pages/UploadBotsol'),
        },
        {
          name: 'Cargar botsol csv',
          path: 'EnabDisabBotsol',
          component: () => import('@/views/admin/pages/EnabDisabBotsol'),
        },
        {
          name: 'Mantenedor subcategorias',
          path: 'subcategories',
          component: () => import('@/views/admin/pages/Subcategories'),
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/referals',
      name: 'Referals',
      component: () => import('@/views/referals/Index'),
      children: [
        // informacion de referidos
        {
          name: 'Informacion de referidos',
          path: 'referralsInfo',
          component: () => import('@/views/referals/pages/ReferralsInfo'),
        },
        // informacion de retiros
        {
          name: 'Informacion de retiros',
          path: 'Withdraw',
          component: () => import('@/views/referals/pages/Withdraw'),
        },

      ],
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
  scrollBehavior: function (to, from, savedPosition) {
    if (to.fullPath.includes('store') && from.fullPath.includes('store')) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach(async (to, from, next) => {
  let title = to.name
  if (to.name === 'Transacciones') {
    title = to.params.type
  } else {
    title = to.name
  }
  // console.log(to.name, 'titlew aqui')
  firebase.analytics().setCurrentScreen(title)
  firebase.analytics().logEvent('page_view', { type: 'internal' })
  firebase.analytics().logEvent('screen_view', {
    app_name: 'pwa',
    screen_name: title,
    app_version: version,
  })
  if (to.name === 'home') {
    /* if (await firebase.auth().currentUser || store.state.users.user) {
      next('/dashboard')
    } else {
      next('/pages/login')
    } */
    window.location.href = 'https://admin-tender.web.app/#/pages/login'
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (await firebase.auth().currentUser || store.state.users.user) {
        if (to.path.toUpperCase().includes('ADMIN')) {
          const adminRoll = store.state.users.profile
          if (adminRoll.admin) {
            next()
          } else {
            next('/dashboard')
          }
        } else if (to.path.toUpperCase().includes('REFERALS')) {
          const canHaveReferrals = store.state.users.profile.canHaveReferrals
          if (canHaveReferrals) {
            next()
          } else {
            next('/dashboard')
          }
        } else if (store.state.users.user && store.state.users.user.role === 'Colaborador') {
          if (to.path.toUpperCase().includes('DASHBOARD/PLANS') || to.path.toUpperCase().includes('DASHBOARD/PLANNER')) {
            next('/dashboard')
          } else {
            next()
          }
        } else {
          next()
        }
      } else {
        next('/pages/login')
      }
    } else {
      next()
    }
  }
})

export default router
